import { defineSlotRecipe } from '@chakra-ui/react'

export const continueButton = defineSlotRecipe({
  className: 'ContinueButton',
  slots: ['container', 'continueButton', 'buttonIcon'],
  base: {
    container: {
      backgroundColor: 'brand.primaryTeal',
      '& svg': {
        color: 'brand.primaryShamrockGreen',
      },
    },
  },
})
